import { jsx } from 'react/jsx-runtime';

/** ![strikethroughIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNMTYgNEg5YTMgMyAwIDAgMC0yLjgzIDRNMTQgMTJhNCA0IDAgMCAxIDAgOEg2TTQgMTJoMTYiLz48L3N2Zz4=) */
const strikethroughIcon = /*#__PURE__*/jsx("path", {
  d: "M16 4H9a3 3 0 0 0-2.83 4M14 12a4 4 0 0 1 0 8H6M4 12h16"
});

export { strikethroughIcon };
